import TechnicalCondition from './component'

export default TechnicalCondition
